import { LanguagesEnum } from '../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  add_modal_btn_submit: {
    [LanguagesEnum.English]: 'Submit',
    [LanguagesEnum.Greek]: 'Υποβολή',
  },
  add_modal_btn_cancel: {
    [LanguagesEnum.English]: 'Cancel',
    [LanguagesEnum.Greek]: 'Ακύρωση',
  },
  add_modal_title: {
    [LanguagesEnum.English]: 'Add Graph',
    [LanguagesEnum.Greek]: 'Προσθήκη γραφήματος',
  },
  page_title: {
    [LanguagesEnum.Greek]: 'Dashboard',
    [LanguagesEnum.English]: 'Dashboard',
  },
  schemeType: {
    [LanguagesEnum.Greek]: 'Scheme Type',
    [LanguagesEnum.English]: 'Scheme Type',
  },
  periodLength: {
    [LanguagesEnum.Greek]: 'Period Length',
    [LanguagesEnum.English]: 'Period Length',
  },
  search: {
    [LanguagesEnum.Greek]: 'Filter Results',
    [LanguagesEnum.English]: 'Filter Results',
  },
  clear: {
    [LanguagesEnum.Greek]: 'Clear',
    [LanguagesEnum.English]: 'Clear',
  },
};

export default CONFIGURATION;
